<template>
	<div @touchmove.stop.prevent="() => { }">
		<van-popup v-model="show" position="bottom" :close-on-click-overlay="false">
			<div class="log_box" :style="{
				paddingTop: statusHeight + 'px'
			}">
				<div class="numberpopup-content">
					<log-top @tonumberClose="close" :top-show="keyheight ? true : false" :loginType="loginType"
						@exchange='exchange'></log-top>
					<!-- 验证码登录 -->
					<verification-code v-if="loginType == 0" @send="sendVerificationCode"
						@keyboardheightchange="keyboardheightchange" :isInputFocus='isInputFocus' />
					<!-- 账号登录 -->
					<user-login ref="userlogin" v-if="loginType == 1" @send="accountSend" @onceRegister="exchange"
						@keyboardheightchange="keyboardheightchange" :isInputFocus='isInputFocus' />
					<!-- 注册账号 -->
					<register ref="register" v-if="loginType == 2" @send="registerSend"
						@keyboardheightchange="keyboardheightchange" :isInputFocus='isInputFocus' />
					<!-- 忘记密码 -->
					<forget-password v-if="loginType == 3" @send='exchange' @keyboardheightchange="keyboardheightchange"
						:isInputFocus='isInputFocus'></forget-password>
					<!-- 登录方式 -->
					<login-mode @exchange="exchange" v-if="loginType == 0 || loginType == 1" :loginType="loginType"
						:quick="oneKey" @local="local" />
					<!-- 协议 -->
					<agreement :imgIco='imgIco' :imgIcoactivate="imgIcoactivate" @goAgreement="goAgreement"
						@seletBtn="seletBtn" :seletBtndata="seletBtndata" v-if="loginType <= 2"
						:marginTop="loginType == 0 ? '0' : '0'" :loginType='loginType' />
				</div>
				<!-- 底部安全区占位 -->
				<div class="safe-area"></div>
				<!-- 键盘占位 -->
				<div :style="{ height: keyheight + 'rem' }"></div>
			</div>
		</van-popup>
		<agreeClause-popup :state="loginType" ref="agreePop" :seletBtndata='seletBtndata' :telNumber='phone'
			@goAgreement="goAgreement" @send="agree"></agreeClause-popup>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { sendSms, loginRegister } from "@/api/auth.js"
import { navigateUrl, getAgreementUrl } from "@/utils/index.js"
import { PRIVACY_AGREEMENT, USER_AGREEMENT } from "@/utils/key.js"
import LogTop from "./components/top.vue"
import VerificationCode from "./components/verificationCode.vue"
import UserLogin from "./components/userlogin.vue"
import Register from "./components/register.vue"
import ForgetPassword from "./components/forgetPassword.vue"
import LoginMode from "./components/loginMode.vue"
import Agreement from "./components/agreement.vue"
import AgreementPopup from "@/components/agreeClause-popup/agreeClause-popup.vue"
import md5 from 'js-md5'

import { onPlusReady } from "@/utils/plus.js"

export default {
	name: 'LoginPopup',
	components: {
		LogTop,
		VerificationCode,
		UserLogin,
		Register,
		ForgetPassword,
		LoginMode,
		Agreement,
		AgreementPopup
	},
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			phone: "",
			oneKey: false,
			seletBtndata: false,
			globalData: {},
			loginType: 0,
			NetworkType: false,
			visibleOfExplain: false,
			imgIco: require('@/assets/image/set/unChoose.png'),
			imgIcoactivate: require('@/assets/image/set/choose.png'),
			info: {},
			stateCode: 0,
			keyheight: 0,
			isInputFocus: false
		}
	},
	computed: {
		statusHeight() {
		  return this.$store.state.statusBarHeight
		},
		...mapState({
			loginpop: state => state.popup.loginpop,
			updateAPP: state => state.popup.updateAPP,
		}),
		show: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			}
		},
	  wulinShareParams() {
	    return this.$store.state.activity.wulinShareParams
	  }
	},
	created() {
		this.globalData = {
			privacy_agreement: localStorage.getItem(PRIVACY_AGREEMENT),
			user_agreement: localStorage.getItem(USER_AGREEMENT),
		}
	},
	mounted() {
		
	},
	watch: {
		loginpop: {
			handler(val) {
				if (val) {
		console.log(this.$store.state.activity.wulinShareParams, 'wulinShareParams');
					this.doOpen()
				} else {
					const currentRoute = this.$route.path
					if (currentRoute === '/user/user') {
						this.$router.push('/index')
					}
				}
			},
			deep: true,
		},
		updateAPP: {
			handler(val) {
				if (val) {
					this.$store.commit("setloginpop", false)
					this.show = false
				}
			}
		}
	},
	methods: {
		...mapActions([
			'loginWithUsername',
			'loginWithShanYan'
		]),
		init() {
			this.info = {}
			this.loginType = 0
			this.phone = ''
			this.stateCode = 0
			localStorage.removeItem('loginPhoneNumber')
		},
		keyboardheightchange(e) {
			this.keyheight = e
		},
		async doOpen() {
			this.isInputFocus = true
			this.show = true
		},
		local(type) {
			if (type === 1) {
				this.show = false
				this.init()
			}
		},
		close() {
			this.show = false
			this.seletBtndata = false
			this.init()
			this.$store.commit('popup/setloginpop', false)
		},
		verification() {
			this.$store.commit('popup/setloginpop', false)
		},
		async goAgreement(type) {
			const data = await getAgreementUrl()
			const user = data.user
			const privacy = data.privacy
			const register_agreement = data.register_agreement

			switch (type) {
				case 1:
					this.$router.push({
						path: '/pages/common/agreement/cloud-agreement',
						query: { type: 'user_agreement' }
					})
					break
				case 2:
					this.$router.push({
						path: '/pages/common/agreement/cloud-agreement',
						query: { type: 'privacy_agreement' }
					})
					break
				case 3:
					this.$router.push({
						path: '/pages/common/agreement/cloud-agreement',
						query: { type: 'register_agreement' }
					})
					break
			}
		},
		exchange(type) {
			this.seletBtndata = false
			this.loginType = type
		},
		agree() {
			this.seletBtn()
			switch (this.loginType) {
				case 1:
					this.userlogin()
					break
				case 2:
					this.registerUser()
					break
			}
		},
		async goVerification() {
			const res = await sendSms({
				phone: this.phone,
				action: 'login',
			})
			if (res.code === 200) {
				this.$toast('验证码发送成功')
				this.verification()
				this.$router.push({
					path: '/pages/index/verification/verification',
					query: { phone: this.phone }
				})
			} else {
				this.$toast(res.msg || '发送失败')
			}
		},
		verifyAgreement() {
			if (!this.seletBtndata) {
				console.log(52555);
				this.$refs.agreePop.doOpen()
				return false
			}
			return true
		},
		sendVerificationCode(phone) {
			console.log(111, phone);
			this.phone = phone
			if (!this.verifyAgreement()) return
			this.goVerification()
		},
		registerSend(info) {
			this.info = info
			if (!this.verifyAgreement()) return
			this.registerUser()
		},
		async registerUser() {
			try {
				const res = await loginRegister(this.info)
				if (res.code === 200) {
					this.$toast('注册成功，欢迎使用')
					this.exchange(1)
				} else if (res.code == -1) {
					this.$store.commit('popup/setPagePopupData', {
						show: true,
						data: {
							phone: res.data.phone,
							register_password: this.info.password,
							func: () => {
								this.exchange(1)
								this.show = false
							}
						}
					})
				} else {
					this.$toast(res.msg)
				}
			} catch (e) {
				console.error('注册失败:', e)
			}
		},
		accountSend(info) {
			this.info = info
			if (!this.verifyAgreement()) return
			this.userlogin()
		},
		async userlogin() {
			const info = {
				...this.info,
				password: md5(this.info.password),
				...this.wulinShareParams
			}
			const [res, banned] = await this.loginWithUsername(info)
			if (res.code === 200) {
				this.$toast('登录成功，欢迎使用')
				this.isInputFocus = false
				this.close()
			} else {
				this.$toast(res.msg)
			}
		},
		seletBtn() {
			this.seletBtndata = !this.seletBtndata
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .van-popup--bottom {
	border-radius: 0;
}

.log_box {
	background: #ffffff;
}

.numberpopup-content {
	width: 100%;
	height: calc(var(--vh, 1vh) * 100);
	// padding: 2rem 0 1.5rem 0;
	box-sizing: border-box;
	background: #ffffff;
	display: flex;
	flex-direction: column;
	align-items: center;
	line-height: normal;
	overflow-y: hidden;
}

.safe-area {
	height: 0.5rem;
}

.flex1 {
	flex: 1;
}
</style>